import common from '../common'

export default {
    list(params) {
      return common.get('/rocheManage/bus/busHospitalLevel/list',params);
    },
  
    add(params) {
      return common.postForm('/rocheManage/bus/busHospitalLevel/add',params);
    },
  
    edit(params) {
      return common.putForm('/rocheManage/bus/busHospitalLevel/edit',params);
    },
  
    delete(params) {
      return common.delete('/rocheManage/bus/busHospitalLevel/delete',params);
    },
  
    deleteBatch(params) {
      return common.delete('/rocheManage/bus/busHospitalLevel/deleteBatch',params);
    },

    exportXls(params) {
      return common.get('/rocheManage/bus/busHospitalLevel/exportXls', params, {responseType: 'blob'});
    },
}


// WEBPACK FOOTER //
// ./src/api/bizmanagement/hospitallevel.js